import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, App } from 'ionic-angular';

import { HomePage } from '../home/home';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  email: any;
  password: any;
  test: any = 'E-logit TEST';
  public loading;
  public result;

  constructor(public navCtrl: NavController, public navParams: NavParams, private alertCtrl: AlertController,
    public loadingController: LoadingController,
    private data: DataProvider,
    public app: App,
    // private device: Device,
    private rest: RestProvider,) {
    
  }

  public ionViewDidEnter(): void {
    document.getElementById('mainMenu').style.display = 'none';
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    return await this.loading.present();
  }

  async stopLoading() {
    return await this.loading.dismiss();
  }

  login() {
    // if (localStorage.getItem('info') != null) {
    //   let nav = this.app.getRootNavs();
    //   nav[0].setRoot(BasicPage);
    // } else {
      this.presentLoadingWithOptions();
      this.rest.login(this.email, this.password).subscribe(res => {
        this.stopLoading();
        if(res.result == 'ok') {
          console.log('result => login => ', res);
          localStorage.setItem('login', this.email);
          localStorage.setItem('password', this.password);
          localStorage.setItem('role', res.role);
          localStorage.setItem('username', res.name);
          localStorage.setItem('activebucket', res.activebucket);
          localStorage.setItem('userId', res.id);
          this.data.username = res.name;
          this.data.role = res.role;
          let nav = this.app.getRootNavs();
          nav[0].setRoot(HomePage);
          // window.location.reload();
        } else {
          this.showAlert('Please insert the correct username or password.');
        }
      }, err => {
        this.stopLoading();
        this.showAlert('Please input correct email or password.');
      });      
    // }
  }

  showAlert(err) {
    let alert = this.alertCtrl.create({
      title: "エラー!",
      subTitle: err,
      buttons: ["OK"]
    });
    alert.present();
  }
  enterKeyHandler(e){
    if(e.keyCode == 13) {
      this.login();
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts